// extracted by mini-css-extract-plugin
module.exports = {"cls1":"TaskWorklistsPage-CssProp3_th-module--cls1--3q7Qi","cls2":"TaskWorklistsPage-CssProp3_th-module--cls2--neutM TaskWorklistsPage-CssProp3_th-module--cls1--3q7Qi"};